// The ONE file name for a bizSAFE audit report: "<report number>-Audit-Report-v<version>.pdf", e.g.
// 1526-Audit-Report-v1.pdf — the same pattern as Internal Audit (32013-Company-v2.pdf). Keep in step with
// supabase/functions/_shared/reportFileName.ts and netlify/functions/render-report-package-background.js.
const pathSafe = s => String(s).replace(/[^\w.-]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '')

export function bizsafeReportName(job, version) {
  const num = (String((job && (job.report_reference_no || job.quote_ref)) || '').match(/\d{3,}/) || [])[0]
    || ((job && job.clients && job.clients.name) || 'Report').replace(/[^\w .&-]/g, '').trim()
  return `${pathSafe(num)}-Audit-Report-v${version}.pdf`
}
